export interface ITimeSelectorWideProps {

}

export enum TimeMode {
    manual = 'manual',
    predefined = 'predefined'
}

export const maxDisplayRowCount = 5;
